import * as ReactIs from "react-is"
import { parsePhoneNumber } from "libphonenumber-js"
import * as Ibantools from "ibantools"

export const isDefined = (obj) => {
	return typeof obj !== "undefined" && obj !== null
}

export const isNotEmpty = (obj) => {
	return typeof obj !== "undefined" && obj !== null && obj !== "" && obj.length !== 0
}

export const isPasswordValid = (str) => {
	const reg = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\W]{8,}$/)
	return !(str.match(reg) === null)
}

export const isEmailValid = (str) => {
	const reg = new RegExp(
		/^([a-zA-Z0-9_\-+.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{1,15}|[0-9]{1,3})(\]?)$/
	)
	return !(str.match(reg) === null)
}

export const isAccountNumberValid = (str) => {
	const reg = new RegExp(/^\d{11}$/)
	return !(str.match(reg) === null)
}

export const isInt = (str) => {
	return /^[0-9]*$/.test(str)
}

export const isSimpleDateFormat = (str) => {
	// Format type 12/08/2021
	return /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)
}

export const isReactElement = (obj) => {
	return ReactIs.isElement(obj)
}

export const isConfirmationCodeValid = (str) => {
	const reg = new RegExp(/^[0-9]{6}$/)
	return !(str.match(reg) === null)
}

export const isSiretValid = (siret) => {
	const size = 14
	if (Number.isNaN(siret) || siret.length !== size) return false
	let bal = 0
	let total = 0
	for (let i = size - 1; i >= 0; i--) {
		const step = (siret.charCodeAt(i) - 48) * (bal + 1)
		total += step > 9 ? step - 9 : step
		bal = 1 - bal
	}
	return total % 10 === 0 ? true : false
}

export const isRnaValid = (rna: string) => {
	// start with W + 9 numbers
	const reg = new RegExp(/^[w,W]\d{9}$/)
	return !(rna.match(reg) == null)
}

export const isValidParsePhoneNumber = (phoneNumber, country) => {
	if (phoneNumber && phoneNumber.length > 2 && country) {
		country = country.toUpperCase()
		const parsedPhoneNumber = parsePhoneNumber(phoneNumber, country)
		return parsedPhoneNumber.isValid()
	}
	return false
}

export const isIBANValid = (str: string) => {
	const cleanStr = str.replace(/\s/g, "")
	return Ibantools.isValidIBAN(cleanStr)
}

export const isBICValid = (str: string) => {
	const cleanStr = str.replace(/\s/g, "")
	return Ibantools.isValidBIC(cleanStr)
}

export const isVATNumberValid = (str: string) => {
	// Test: https://regex101.com/r/lhR5lJ/2 with this regex
	const reg = new RegExp(/^[A-Za-z]{2,4}(?=.{2,12}$)[-_\s0-9]*(?:[a-zA-Z][-_\s0-9]*){0,2}$/)
	return !(str.match(reg) === null)
}

export const isNameValidYouSign = (str: string) => {
	const reg = new RegExp(
		/^(?!\s)[0-9A-Za-zĄÀÁÂÃÄÅÇĆÈÉÊËĘÌÍÎÏŁÑŃÒÓÔÕÖŚÙÚÛÜÝŹŻąàáâãäåæçćèéêëęìíîïłñńòóôõöśùúûüýÿźżß`\'()\- ]+(?<!\s)$/
	)
	return !(str.match(reg) === null)
}
